module.exports = __webpack_public_path__ + "a20f5b5c73fe6ded651537f6e7ce7269.woff";